// extracted by mini-css-extract-plugin
module.exports = {"trail":"trailPage_trail__1p2HD","fadeIn":"trailPage_fadeIn__32Fj9"};